/**
 * Canonical public origin for shareable links.
 *
 * On native (Capacitor) the page origin is `capacitor://localhost` (iOS) or
 * `https://localhost` (Android), which is unusable when shared. On web the
 * origin can also be a preview/published variant (deco-canvas.lovable.app,
 * id-preview--*.lovable.app, etc.). We always emit links pointing at the
 * production custom domain so they resolve for any recipient.
 */
export const PUBLIC_ORIGIN = "https://decorcanvas.design";

export const buildShareUrl = (path: string): string => {
  const clean = path.startsWith("/") ? path : `/${path}`;
  return `${PUBLIC_ORIGIN}${clean}`;
};

/** Pinterest truncates descriptions past 500 chars. */
export const pinterestDescription = (text: string): string =>
  text.length > 500 ? `${text.slice(0, 497)}...` : text;



/**
 * Link handed to social networks / link-preview crawlers.
 *
 * The published site is a static SPA, so crawlers fetching
 * `/explore?design=<id>` only see the site-wide Open Graph tags. The
 * `explore-og` edge function serves per-design OG tags to crawlers and 302s
 * real browsers to `/explore?design=<id>`, so sharing this URL makes the
 * actual design image show up as the preview card.
 */
export const buildSocialShareUrl = (designId: string): string =>
  `https://pseuqcfvzaknrbeknpal.supabase.co/functions/v1/explore-og?design=${encodeURIComponent(designId)}`;
